import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ScatterChartWidget = ({ data }) => {
    const { t } = useTranslation();
    const chartData = Array.isArray(data) ? data : [];

    if (chartData.length === 0) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <p style={{ color: '#999' }}>{t('NO_DATA_AVAILABLE')}</p>
            </div>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <ScatterChart>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="x" name="X" />
                <YAxis dataKey="y" name="Y" />
                <Tooltip cursor={{ strokeDasharray: '3 3' }} />
                <Scatter name="Data Points" data={chartData} fill="#0078D4" />
            </ScatterChart>
        </ResponsiveContainer>
    );
};

export default ScatterChartWidget;
